/** Shared closing section for grant opportunity checklists. */
export const ACCOUNTING_FINANCE_SECTION_NAME = "Accounting & Finance";

export function createAccountingFinanceSection(sectionId) {
  return {
    id: sectionId,
    name: ACCOUNTING_FINANCE_SECTION_NAME,
    completed: false,
    subtasks: [
      { id: `${sectionId}-1`, name: "Invoice the client", completed: false },
      { id: `${sectionId}-2`, name: "Collect funds", completed: false },
    ],
  };
}

/** Append accounting section if not already present. */
export function appendAccountingFinanceSection(tasks) {
  if (!Array.isArray(tasks) || tasks.length === 0) return tasks;

  const hasSection = tasks.some(
    (task) =>
      (task?.name || "").trim().toLowerCase() ===
      ACCOUNTING_FINANCE_SECTION_NAME.toLowerCase()
  );
  if (hasSection) return tasks;

  const numericIds = tasks.map((task) => {
    const parsed =
      typeof task.id === "number" ? task.id : parseInt(String(task.id), 10);
    return Number.isFinite(parsed) ? parsed : 0;
  });
  const sectionId = Math.max(0, ...numericIds) + 1;

  return [...tasks, createAccountingFinanceSection(sectionId)];
}
